import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "    <span class='fire-lazy-load'></span>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"immediate") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":0},"end":{"line":8,"column":7}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/lazy-load-module",
  "version": "1.0.1",
  "id": "lazyLoadModule",
  "containerID": "homeLoansLazyLoadModule",
  "moduleName": "home-loans-lazy-load-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "lazy-load-module",
  "data": {
    "init": "lazyLoadModuleJS",
    "options": {}
  },
  "moduleParams": [{
    "name": "immediate",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": ""
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/*
 * lazy-load-module
 * module_js_id: lazyLoadModuleJS
 *
 * Copyright (c) 2016-6-29 me
 */

/**
 * @class laxyLoadModuleJS
 * @extends Module
 */
class lazyLoadModuleJS extends Module {
  /**
   * @method constructor
   * @param {Object} options module params
   * @param {Object} context module params
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * @method init
   * @returns {void}
   */
  init() {
    const context = this;
    if ($('.fire-lazy-load').length > 0) {
      this.pageReady();
    }
    const events = {
      pageReady: ['PAGE_READY', 'HOME_LOANS_GENERIC_SUCCESS', 'HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS', 'HOME_LOANS_MORTGAGE_CALCULATOR_RATES_REQUEST_SUCCESS', 'HOME_LOANS_MORTGAGE_CALCULATOR_RATES_REQUEST_FAILURE', 'HOME_LOANS_REFINANCE_CALCULATOR_RATES_REQUEST_SUCCESS', 'HOME_LOANS_REFINANCE_CALCULATOR_RATES_REQUEST_FAILURE', 'HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE', 'HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS', 'HOME_LOANS_REFINANCE_RATES_REQUEST_FAILURE', 'HOME_LOANS_HOME_EQUITY_RATES_REQUEST_SUCCESS', 'HOME_LOANS_HOME_EQUITY_RATES_REQUEST_FAILURE', 'HOME_LOANS_MORTGAGE_OVERVIEW_ROUTE_UPDATED', 'HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_SUCCESS', 'HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_SUCCESS', 'HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_SUCCESS', 'HOME_LOANS_OVERVIEW_MORTGAGE_RATES_REQUEST_FAILURE', 'HOME_LOANS_OVERVIEW_REFINANCE_RATES_REQUEST_FAILURE', 'HOME_LOANS_OVERVIEW_HOME_EQUITY_RATES_REQUEST_FAILURE', 'HOME_LOANS_LEARNING_OVERVIEW_ROUTE_UPDATED']
    };

    // this configures events{};
    // Array names are the functions that are
    // called when corresponding event fires.
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const func in events) {
      for (let x = 0; x < events[func].length; x++) {
        context.Events.sub(events[func][x], () => {
          context[func]();
        });
      }
    }
  }

  /**
   * @method pageReady
   * @returns {void}
   */
  pageReady() {
    const $spinner = $('#spinnerModule');
    $spinner.fadeOut({
      duration: 200,
      easing: 'linear'
    });
    $('body').addClass('page-ready');
    $('.lazy-load-module ~ [data-module]').length;
  }
}
registerModuleClass({
  moduleClass: lazyLoadModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { lazyLoadModuleJS as default, moduleConfig };
